// extracted by mini-css-extract-plugin
module.exports = {"aside_container":"style_aside_container__tloDi","message__mobile_chat":"style_message__mobile_chat__u1jCL"};